<template>
  <el-dialog
  :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="合同签署"
    width="500px"
  >
    <div class="el_eject_midel">
          合同可以有效地保证双方的利益避免交易损失，减少争议纠纷。
            我们为您提供以下两种合同签署方式，请选择合适您的方式
   </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="showLocalDialog">上传本地合同</el-button>
      <el-button @click="showOnlineDialog">使用平台合同</el-button>
    </span>

    <contract-online-dialog ref="onlineDialog" @refresh="refresh"></contract-online-dialog>
    <contract-local-dialog ref="localDialog"></contract-local-dialog>


  </el-dialog>
</template>

<script>
   import contractOnlineDialog from './contract-online-dialog.vue'
   import contractLocalDialog from './contract-local-dialog.vue'


//import { contractShow,contractUpdate} from "@/api/director/work/recruit/index";

export default {
  components: {
      contractOnlineDialog,contractLocalDialog
  },
  data() {
    return {
      visible: false,
      enroll_id:'',
      formData: {
        enroll_id:[],
        contract_type:1,
        relation_status:"12",
      },
      contractInfo:{
        id: "",
        contract_name: "",
        contract_text: "",
        contract_mark: "",
        contract_file: "",
        contract_fname: "",
        status: 1,
       
      }
    
    };
  },

 
  mounted() {

  },
  
  methods: {
    showOnlineDialog(){
        this.$refs.onlineDialog.init(this.enroll_id);
     },

     showLocalDialog(){
        this.$refs.localDialog.init(this.enroll_id);
     },

     
     refresh(){
        this.visible = false;
        this.$emit("refresh");
     },

    handleClose() {
      this.visible = false;
     // this.$refs["form"].resetFields();

    },

    init(enroll_id) {
      this.visible = true;
      this.enroll_id=enroll_id;

      contractShow({}).then((response) => {
          if(response.code==200){
            this.contractInfo=response.data;
          }
      });
    },


  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;





.el_eject_midel{
    margin-top: 32px;
    margin-left: 28px;
    margin-right: 28px;
   text-align: left;
   font-size: 19px;
   line-height: 38px;
  color: #333333;
  margin-bottom: 127px;
  }

/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
